import React, { Component } from 'react';
import head from '../img/head.png';

export default class Header extends React.Component {
  render() {
    return(
        <div className="header">
            <img src={head} className="App-logo" alt="head" />
        </div>
    ); 
  }
}


// WEBPACK FOOTER //
// ./src/component/Header.js